<template>
  <div class="formatos">
    <!-- Title -->
    <svg width="261" height="74" viewBox="0 0 261 74" fill="none" xmlns="http://www.w3.org/2000/svg" class="title">
      <path
          d="M84.0784 31.992C85.9184 31.992 87.5824 32.288 89.0704 32.88C90.5744 33.472 91.8544 34.312 92.9104 35.4C93.9664 36.488 94.7824 37.816 95.3584 39.384C95.9344 40.952 96.2224 42.704 96.2224 44.64C96.2224 46.592 95.9344 48.352 95.3584 49.92C94.7824 51.488 93.9664 52.824 92.9104 53.928C91.8544 55.032 90.5744 55.88 89.0704 56.472C87.5824 57.064 85.9184 57.36 84.0784 57.36C82.2384 57.36 80.5664 57.064 79.0624 56.472C77.5584 55.88 76.2704 55.032 75.1984 53.928C74.1424 52.824 73.3184 51.488 72.7264 49.92C72.1504 48.352 71.8624 46.592 71.8624 44.64C71.8624 42.704 72.1504 40.952 72.7264 39.384C73.3184 37.816 74.1424 36.488 75.1984 35.4C76.2704 34.312 77.5584 33.472 79.0624 32.88C80.5664 32.288 82.2384 31.992 84.0784 31.992ZM84.0784 52.8C86.1264 52.8 87.6384 52.112 88.6144 50.736C89.6064 49.36 90.1024 47.344 90.1024 44.688C90.1024 42.032 89.6064 40.008 88.6144 38.616C87.6384 37.224 86.1264 36.528 84.0784 36.528C81.9984 36.528 80.4624 37.232 79.4704 38.64C78.4784 40.032 77.9824 42.048 77.9824 44.688C77.9824 47.328 78.4784 49.344 79.4704 50.736C80.4624 52.112 81.9984 52.8 84.0784 52.8ZM100.848 57V32.376H104.328C104.936 32.376 105.36 32.488 105.6 32.712C105.84 32.936 106 33.32 106.08 33.864L106.44 36.84C107.32 35.32 108.352 34.12 109.536 33.24C110.72 32.36 112.048 31.92 113.52 31.92C114.736 31.92 115.744 32.2 116.544 32.76L115.776 37.2C115.728 37.488 115.624 37.696 115.464 37.824C115.304 37.936 115.088 37.992 114.816 37.992C114.576 37.992 114.248 37.936 113.832 37.824C113.416 37.712 112.864 37.656 112.176 37.656C110.944 37.656 109.888 38 109.008 38.688C108.128 39.36 107.384 40.352 106.776 41.664V57H100.848ZM120.441 57V32.376H124.065C124.833 32.376 125.337 32.736 125.577 33.456L125.961 35.28C126.393 34.8 126.841 34.36 127.305 33.96C127.785 33.56 128.289 33.216 128.817 32.928C129.361 32.64 129.937 32.416 130.545 32.256C131.169 32.08 131.849 31.992 132.585 31.992C134.137 31.992 135.409 32.416 136.401 33.264C137.409 34.096 138.161 35.208 138.657 36.6C139.041 35.784 139.521 35.088 140.097 34.512C140.673 33.92 141.305 33.44 141.993 33.072C142.681 32.704 143.409 32.432 144.177 32.256C144.961 32.08 145.745 31.992 146.529 31.992C147.889 31.992 149.097 32.2 150.153 32.616C151.209 33.032 152.097 33.64 152.817 34.44C153.537 35.24 154.081 36.216 154.449 37.368C154.833 38.52 155.025 39.84 155.025 41.328V57H149.097V41.328C149.097 39.76 148.753 38.584 148.065 37.8C147.377 37 146.369 36.6 145.041 36.6C144.433 36.6 143.865 36.704 143.337 36.912C142.825 37.12 142.369 37.424 141.969 37.824C141.585 38.208 141.281 38.696 141.057 39.288C140.833 39.88 140.721 40.56 140.721 41.328V57H134.769V41.328C134.769 39.68 134.433 38.48 133.761 37.728C133.105 36.976 132.129 36.6 130.833 36.6C129.985 36.6 129.185 36.816 128.433 37.248C127.697 37.664 127.009 38.24 126.369 38.976V57H120.441ZM180.144 57H177.48C176.92 57 176.48 56.92 176.16 56.76C175.84 56.584 175.6 56.24 175.44 55.728L174.912 53.976C174.288 54.536 173.672 55.032 173.064 55.464C172.472 55.88 171.856 56.232 171.216 56.52C170.576 56.808 169.896 57.024 169.176 57.168C168.456 57.312 167.656 57.384 166.776 57.384C165.736 57.384 164.776 57.248 163.896 56.976C163.016 56.688 162.256 56.264 161.616 55.704C160.992 55.144 160.504 54.448 160.152 53.616C159.8 52.784 159.624 51.816 159.624 50.712C159.624 49.784 159.864 48.872 160.344 47.976C160.84 47.064 161.656 46.248 162.792 45.528C163.928 44.792 165.44 44.184 167.328 43.704C169.216 43.224 171.56 42.952 174.36 42.888V41.448C174.36 39.8 174.008 38.584 173.304 37.8C172.616 37 171.608 36.6 170.28 36.6C169.32 36.6 168.52 36.712 167.88 36.936C167.24 37.16 166.68 37.416 166.2 37.704C165.736 37.976 165.304 38.224 164.904 38.448C164.504 38.672 164.064 38.784 163.584 38.784C163.184 38.784 162.84 38.68 162.552 38.472C162.264 38.264 162.032 38.008 161.856 37.704L160.776 35.808C163.608 33.216 167.024 31.92 171.024 31.92C172.464 31.92 173.744 32.16 174.864 32.64C176 33.104 176.96 33.76 177.744 34.608C178.528 35.44 179.12 36.44 179.52 37.608C179.936 38.776 180.144 40.056 180.144 41.448V57ZM168.624 53.304C169.232 53.304 169.792 53.248 170.304 53.136C170.816 53.024 171.296 52.856 171.744 52.632C172.208 52.408 172.648 52.136 173.064 51.816C173.496 51.48 173.928 51.088 174.36 50.64V46.488C172.632 46.568 171.184 46.72 170.016 46.944C168.864 47.152 167.936 47.424 167.232 47.76C166.528 48.096 166.024 48.488 165.72 48.936C165.432 49.384 165.288 49.872 165.288 50.4C165.288 51.44 165.592 52.184 166.2 52.632C166.824 53.08 167.632 53.304 168.624 53.304ZM194.061 57.384C191.933 57.384 190.293 56.784 189.141 55.584C187.989 54.368 187.413 52.696 187.413 50.568V36.816H184.917C184.597 36.816 184.317 36.712 184.077 36.504C183.853 36.296 183.741 35.984 183.741 35.568V33.216L187.701 32.568L188.949 25.848C189.013 25.528 189.157 25.28 189.381 25.104C189.621 24.928 189.917 24.84 190.269 24.84H193.341V32.592H199.821V36.816H193.341V50.16C193.341 50.928 193.533 51.528 193.917 51.96C194.301 52.392 194.813 52.608 195.453 52.608C195.821 52.608 196.125 52.568 196.365 52.488C196.621 52.392 196.837 52.296 197.013 52.2C197.205 52.104 197.373 52.016 197.517 51.936C197.661 51.84 197.805 51.792 197.949 51.792C198.125 51.792 198.269 51.84 198.381 51.936C198.493 52.016 198.613 52.144 198.741 52.32L200.517 55.2C199.653 55.92 198.661 56.464 197.541 56.832C196.421 57.2 195.261 57.384 194.061 57.384ZM215.047 31.992C216.887 31.992 218.551 32.288 220.039 32.88C221.543 33.472 222.823 34.312 223.879 35.4C224.935 36.488 225.751 37.816 226.327 39.384C226.903 40.952 227.191 42.704 227.191 44.64C227.191 46.592 226.903 48.352 226.327 49.92C225.751 51.488 224.935 52.824 223.879 53.928C222.823 55.032 221.543 55.88 220.039 56.472C218.551 57.064 216.887 57.36 215.047 57.36C213.207 57.36 211.535 57.064 210.031 56.472C208.527 55.88 207.239 55.032 206.167 53.928C205.111 52.824 204.287 51.488 203.695 49.92C203.119 48.352 202.831 46.592 202.831 44.64C202.831 42.704 203.119 40.952 203.695 39.384C204.287 37.816 205.111 36.488 206.167 35.4C207.239 34.312 208.527 33.472 210.031 32.88C211.535 32.288 213.207 31.992 215.047 31.992ZM215.047 52.8C217.095 52.8 218.607 52.112 219.583 50.736C220.575 49.36 221.071 47.344 221.071 44.688C221.071 42.032 220.575 40.008 219.583 38.616C218.607 37.224 217.095 36.528 215.047 36.528C212.967 36.528 211.431 37.232 210.439 38.64C209.447 40.032 208.951 42.048 208.951 44.688C208.951 47.328 209.447 49.344 210.439 50.736C211.431 52.112 212.967 52.8 215.047 52.8ZM246.432 37.176C246.272 37.432 246.104 37.616 245.928 37.728C245.752 37.824 245.528 37.872 245.256 37.872C244.968 37.872 244.656 37.792 244.32 37.632C244 37.472 243.624 37.296 243.192 37.104C242.76 36.896 242.264 36.712 241.704 36.552C241.16 36.392 240.512 36.312 239.76 36.312C238.592 36.312 237.672 36.56 237 37.056C236.328 37.552 235.992 38.2 235.992 39C235.992 39.528 236.16 39.976 236.496 40.344C236.848 40.696 237.304 41.008 237.864 41.28C238.44 41.552 239.088 41.8 239.808 42.024C240.528 42.232 241.264 42.464 242.016 42.72C242.768 42.976 243.504 43.272 244.224 43.608C244.944 43.928 245.584 44.344 246.144 44.856C246.72 45.352 247.176 45.952 247.512 46.656C247.864 47.36 248.04 48.208 248.04 49.2C248.04 50.384 247.824 51.48 247.392 52.488C246.96 53.48 246.328 54.344 245.496 55.08C244.664 55.8 243.632 56.368 242.4 56.784C241.184 57.184 239.784 57.384 238.2 57.384C237.352 57.384 236.52 57.304 235.704 57.144C234.904 57 234.128 56.792 233.376 56.52C232.64 56.248 231.952 55.928 231.312 55.56C230.688 55.192 230.136 54.792 229.656 54.36L231.024 52.104C231.2 51.832 231.408 51.624 231.648 51.48C231.888 51.336 232.192 51.264 232.56 51.264C232.928 51.264 233.272 51.368 233.592 51.576C233.928 51.784 234.312 52.008 234.744 52.248C235.176 52.488 235.68 52.712 236.256 52.92C236.848 53.128 237.592 53.232 238.488 53.232C239.192 53.232 239.792 53.152 240.288 52.992C240.8 52.816 241.216 52.592 241.536 52.32C241.872 52.048 242.112 51.736 242.256 51.384C242.416 51.016 242.496 50.64 242.496 50.256C242.496 49.68 242.32 49.208 241.968 48.84C241.632 48.472 241.176 48.152 240.6 47.88C240.04 47.608 239.392 47.368 238.656 47.16C237.936 46.936 237.192 46.696 236.424 46.44C235.672 46.184 234.928 45.888 234.192 45.552C233.472 45.2 232.824 44.76 232.248 44.232C231.688 43.704 231.232 43.056 230.88 42.288C230.544 41.52 230.376 40.592 230.376 39.504C230.376 38.496 230.576 37.536 230.976 36.624C231.376 35.712 231.96 34.92 232.728 34.248C233.512 33.56 234.48 33.016 235.632 32.616C236.8 32.2 238.144 31.992 239.664 31.992C241.36 31.992 242.904 32.272 244.296 32.832C245.688 33.392 246.848 34.128 247.776 35.04L246.432 37.176Z"
          fill="white"/>
      <path d="M32.2142 7.38171C32.2142 26.8282 34.0951 85.1375 34.0951 65.691" stroke="white" stroke-width="8"
            stroke-linecap="round"/>
      <path
          d="M4 25.2507C31.1053 18.3168 57.8456 10.533 85.1941 4.56031C88.7877 3.77548 90.0177 3.26375 87.6497 6.96374C85.7665 9.90627 84.226 12.5757 82.9996 15.846"
          stroke="white" stroke-width="8" stroke-linecap="round"/>
      <path d="M19.0475 51.5839C29.7917 47.3839 40.3604 44.0601 51.9641 44.0601" stroke="white" stroke-width="8"
            stroke-linecap="round"/>
    </svg>

    <div class="content" style="padding-bottom: 12px">
      <p class="heading" style="text-align: center; color: #FFFFFF">
        El torneo contará con dos dinámicas de juego: La COPA ONLINE y la ARENA PRESENCIAL de Diagonal Mar.
        <br>
      </p>
    </div>
    <div class="content" style="padding-bottom: 12px">
      <p class="heading" style="text-align: center; color: #FFFFFF">

        Por un lado, la COPA ONLINE se jugará a través de Play Station 4 los días 6 y 7 de marzo, en donde los 8 mejores
        jugadores resultantes del torneo competirán por la victoria de manera presencial en la arena de Diagonal Mar el
        sábado 11 de marzo.

        <br>
      </p>
    </div>
    <div class="content" style="padding-bottom: 25px">
      <p class="heading" style="text-align: center; color: #FFFFFF">
        Por otro lado, la ARENA PRESENCIAL se jugará en Diagonal Mar desde el 8 hasta el 11 de marzo. Para participar,
        el único requisito solicitado es contar con la App Diagonal Mar, y, de esta manera, los participantes
        podrán competir por increíbles premios diarios y la tan ansiada Play Station 5, la cual la obtendrá el ganador
        del ranking general.

        <br>
      </p>
    </div>
    <div class="content">
      <div class="left wrapper" style="place-self: center">
        <div class="heading-wrapper">
          <svg width="75" height="75" viewBox="0 0 75 75" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_33_39" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="4" y="3" width="67"
                  height="68">
              <path
                  d="M21.0938 61.5161C25.7686 65.1987 31.5489 67.197 37.5 67.188C43.6922 67.188 49.3906 65.0693 53.9062 61.5161M29.6875 15.2302C18.8297 18.5661 10.9375 28.6739 10.9375 40.6255C10.9375 43.6333 11.4375 46.5239 12.3594 49.2193M45.3125 15.2302C56.1703 18.5661 64.0625 28.6739 64.0625 40.6255C64.0625 43.6333 63.5625 46.5239 62.6406 49.2193"
                  stroke="white" stroke-width="5.83333"/>
              <path
                  d="M67.1875 56.2505C67.1875 58.3474 66.3625 60.2505 65.0188 61.6536C63.7639 62.9646 62.0918 63.7978 60.2895 64.0103C58.4872 64.2227 56.6672 63.8011 55.1419 62.8178C53.6167 61.8345 52.4813 60.3509 51.9307 58.6216C51.3801 56.8924 51.4488 55.0255 52.1248 53.3413C52.8008 51.6572 54.042 50.2609 55.6353 49.3922C57.2286 48.5235 59.0747 48.2366 60.8565 48.5807C62.6383 48.9249 64.2448 49.8786 65.4 51.2781C66.5553 52.6777 67.1873 54.4358 67.1875 56.2505ZM23.4375 56.2505C23.4375 58.3474 22.6125 60.2505 21.2688 61.6536C20.0139 62.9646 18.3418 63.7978 16.5395 64.0103C14.7372 64.2227 12.9172 63.8011 11.3919 62.8178C9.86666 61.8345 8.73127 60.3509 8.18071 58.6216C7.63015 56.8924 7.69875 55.0255 8.37475 53.3413C9.05075 51.6572 10.292 50.2609 11.8853 49.3922C13.4786 48.5235 15.3247 48.2366 17.1065 48.5807C18.8883 48.9249 20.4948 49.8786 21.65 51.2781C22.8053 52.6777 23.4373 54.4358 23.4375 56.2505ZM45.3125 14.063C45.3125 16.1599 44.4875 18.063 43.1438 19.4661C41.8889 20.7771 40.2168 21.6103 38.4145 21.8228C36.6122 22.0352 34.7922 21.6136 33.2669 20.6303C31.7417 19.647 30.6063 18.1634 30.0557 16.4341C29.5051 14.7049 29.5738 12.838 30.2498 11.1538C30.9258 9.46966 32.167 8.07338 33.7603 7.20469C35.3536 6.336 37.1997 6.0491 38.9815 6.39324C40.7633 6.73737 42.3698 7.69109 43.525 9.09063C44.6803 10.4902 45.3123 12.2482 45.3125 14.063Z"
                  fill="white" stroke="white" stroke-width="5.83333" stroke-linecap="round" stroke-linejoin="round"/>
            </mask>
            <g mask="url(#mask0_33_39)">
              <path d="M0 0.00050354H75V75.0005H0V0.00050354Z" fill="white"/>
            </g>
          </svg>
          <h2 class="heading">copa Online (PS4)</h2>
        </div>
        <p class="text">6 - 7 Marzo<br> Final - 11 de Marzo<br>Diagonal Mar - Planta Baja - Plaza Central</p>
      </div>
      <div class="v-line"></div>
      <div class="right wrapper" style="place-self: center">
        <div class="heading-wrapper">
          <svg width="72" height="66" viewBox="0 0 72 66" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M39.8025 6.90556L37.1475 0.803982C36.7087 -0.255496 35.3362 -0.293791 34.8525 0.803982L32.1975 6.90556L26.3137 7.86292C25.2675 8.04162 24.8175 9.50958 25.5938 10.3903L29.8687 15.1133L28.8562 21.7638C28.6987 22.9509 29.7787 23.87 30.7462 23.3211L36.0225 20.1554L41.265 23.27C42.2325 23.8189 43.3237 22.8999 43.155 21.7127L42.1425 15.0623L46.4175 10.3903C47.1825 9.52234 46.7437 8.05439 45.6975 7.86292L39.8137 6.90556H39.8025ZM28.8 32.6777C26.8088 32.6777 25.2 34.5031 25.2 36.7624V61.2708C25.2 63.5302 26.8088 65.3556 28.8 65.3556H43.2C45.1912 65.3556 46.8 63.5302 46.8 61.2708V36.7624C46.8 34.5031 45.1912 32.6777 43.2 32.6777H28.8ZM3.6 40.8472C1.60875 40.8472 0 42.6725 0 44.9319V61.2708C0 63.5302 1.60875 65.3556 3.6 65.3556H18C19.9912 65.3556 21.6 63.5302 21.6 61.2708V44.9319C21.6 42.6725 19.9912 40.8472 18 40.8472H3.6ZM50.4 53.1014V61.2708C50.4 63.5302 52.0088 65.3556 54 65.3556H68.4C70.3913 65.3556 72 63.5302 72 61.2708V53.1014C72 50.842 70.3913 49.0166 68.4 49.0166H54C52.0088 49.0166 50.4 50.842 50.4 53.1014Z"
                fill="white"/>
          </svg>
          <h2 class="heading">Arena presencial</h2>
        </div>
        <p class="text">8 - 11 Marzo<br> Diagonal Mar - Planta Baja - Plaza Central</p></div>
    </div>
    <img src="@/assets/hex.svg" alt="" class="hexagon1">
    <img src="@/assets/hexagon1.svg" alt="" class="hexagon2">
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.formatos {
  position: relative;
  width: 100%;
  background: #0092bc;
  padding: 65px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  @media only screen and (max-width: 580px) {
    padding: 40px 10px;
  }

  .hexagon1 {
    position: absolute;
    top: 0;
    right: 0;
    @media only screen and (max-width: 580px) {
      width: 100px;
    }
    @media only screen and (max-width: 580px) {
      width: 60px;
    }
  }

  .hexagon2 {
    position: absolute;
    bottom: 0;
    left: 0;
    @media only screen and (max-width: 780px) {
      width: 200px;
    }
    @media only screen and (max-width: 780px) {
      width: 150px;
    }
  }

  .title {
    margin-bottom: 35px;
    @media only screen and (max-width: 780px) {
      width: 200px;
      margin-bottom: 35px;
    }
    @media only screen and (max-width: 580px) {
      width: 150px;
      margin-bottom: 20px;
    }
  }

  .content {
    display: flex;
    justify-content: center;
    align-items: flex-start;

    .wrapper {
      width: 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;

      .heading-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
        @media only screen and (max-width: 580px) {
          margin-bottom: 10px;
        }

        svg {
          margin-right: 20px;
          min-width: 70px;
          min-height: 70px;
          @media only screen and (max-width: 780px) {
            min-width: 35px;
            min-height: 35px;
            width: 35px;
            height: 35px;
          }
          @media only screen and (max-width: 580px) {
            margin-right: 10px;
            min-width: 25px;
            min-height: 25px;
            width: 25px;
            height: 25px;
          }
        }

        .heading {
          font-weight: 700;
          font-size: 40px;
          line-height: 48px;
          text-align: center;
          color: #FFF;
          text-transform: capitalize;
          @media only screen and (max-width: 780px) {
            font-size: 30px;
            line-height: 38px;
          }
          @media only screen and (max-width: 580px) {
            font-size: 20px;
            line-height: 22px;
          }
        }
      }

      .text {
        font-weight: 400;
        font-size: 32px;
        line-height: 38px;
        text-align: center;
        padding-left: 45px;
        color: #FFF;
        width: fit-content;
        @media only screen and (max-width: 780px) {
          width: fit-content;
          font-size: 24px;
          line-height: 28px
        }
        @media only screen and (max-width: 580px) {
          font-size: 14px;
          line-height: 18px
        }
      }
    }

    .v-line {
      width: 4px;
      height: 200px;
      background: #FFFFFF;
      border-radius: 10px;
      @media only screen and (max-width: 780px) {
        width: 2px;
      }
    }

    .left {
      padding-right: 130px;
      @media only screen and (max-width: 780px) {
        padding-right: 50px;
      }
      @media only screen and (max-width: 580px) {
        padding-right: 15px;
      }
    }

    .right {
      padding-left: 130px;
      @media only screen and (max-width: 780px) {
        padding-left: 50px;
      }
      @media only screen and (max-width: 580px) {
        padding-left: 15px;
      }
    }
  }
}

</style>